import { z } from 'zod';
import { DateSchema } from './base.schema';

/**
 * Audit schema for tracking entity metadata.
 */
export const AuditSchema = z.object({
  createdAt: DateSchema,
  updatedAt: DateSchema,
});

export type Audit = z.infer<typeof AuditSchema>;
